// extracted by mini-css-extract-plugin
export var bgImg = "cardSmall-module--bgImg--01c50";
export var category = "cardSmall-module--category--a7ced";
export var categoryLink = "cardSmall-module--categoryLink--3e2cd";
export var categoryLinkWrapper = "cardSmall-module--categoryLinkWrapper--3e94a";
export var content = "cardSmall-module--content--1c6cc";
export var hasBgImg = "cardSmall-module--hasBgImg--fa1fa";
export var heading = "cardSmall-module--heading--4e4b0";
export var img = "cardSmall-module--img--8d94d";
export var imgContainer = "cardSmall-module--imgContainer--5d6e0";
export var inner = "cardSmall-module--inner--cacf0";
export var link = "cardSmall-module--link--d1678";
export var linkLabel = "cardSmall-module--linkLabel--f1056";
export var linkWrapper = "cardSmall-module--linkWrapper--f131c";
export var subHeading = "cardSmall-module--subHeading--14f50";
export var text = "cardSmall-module--text--18902";
export var wrapper = "cardSmall-module--wrapper--1fc75";